"use client"
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-bootstrap";
import AssetContent from "@/components/shared/AssetContent";

import "@/components/shared/Asset.css";
import UralityAudio from "@/components/shared/UralityAudio";

const Asset = ({ autoPlay, assets, height, showCaption, onDelete }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [width, setWidth] = useState(null);
  const [activeAsset, setActiveAsset] = useState(null);

  const [audioAssets, setAudioAssets] = useState([]);
  const [nonAudioAssets, setNonAudioAssets] = useState([]);

  useEffect(() => {
    if (assets) {
      setNonAudioAssets(assets.filter(asset => asset.assetType !== "AUDIO"));
      setAudioAssets(assets.filter(asset => asset.assetType === "AUDIO"));
    }
  }, [assets]);

  useEffect(() => {
    if (nonAudioAssets && nonAudioAssets.length > 0) {
      setActiveAsset(nonAudioAssets[activeIndex]);
    }
  }, [nonAudioAssets, activeIndex]);

  // const wrapper = element => {
  //   if (element) {
  //     setWidth(element.getBoundingClientRect().width);
  //   }
  // };

  const style = height ? { height: height } : {};

  const renderArrowPrev = (
    <div className="render-arrow-prev">
      <div className="arrow with-icon">
        <span className="material-icons">chevron_left</span>
      </div>
    </div>
  );

  const renderArrowNext = (
    <div className="render-arrow-next">
      <div className="arrow with-icon">
        <span className="material-icons">chevron_right</span>
      </div>
    </div>
  );

  const nonAudioContent = () => {
    const numAssets = nonAudioAssets.length;

    let content;
    if (numAssets > 1) {
      var carouselItems =
        nonAudioAssets &&
        nonAudioAssets.map(function(asset, index) {
          return (
            <AssetContent
              asset={asset}
              width={width}
              autoPlay={autoPlay}
              showCaption={false}
              onDelete={onDelete}
            >
              {onDelete && (
                <div className="delete-button">
                  <button
                    type="button"
                    className="a"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDelete(asset.id);
                    }}
                  >
                    <span className="material-icons">delete</span>
                  </button>
                </div>
              )}
            </AssetContent>
          );
        });
      content = (
        // <div ref={wrapper}>
        <div>
          <Carousel
            fade
            className=""
            interval={null}
            activeIndex={activeIndex}
            indicators={true}
            onSelect={eventKey => setActiveIndex(eventKey)}
            prevIcon={renderArrowPrev}
            nextIcon={renderArrowNext}
          >
            {carouselItems.map(function(elem, index) {
              return <Carousel.Item>{elem}</Carousel.Item>;
            })}
          </Carousel>
        </div>
      );
    } else {
      content = (
        // <div ref={wrapper}>
        <div>
          <AssetContent
            asset={nonAudioAssets[0]}
            width={width}
            autoPlay={autoPlay}
            showCaption={showCaption}
          >
            {onDelete && (
              <div className="delete-button">
                <button
                  type="button"
                  className="a"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDelete(nonAudioAssets[0].id);
                  }}
                >
                  <span className="material-icons">delete</span>
                </button>
              </div>
            )}
          </AssetContent>
        </div>
      );
    }
    return content;
  };

  return (
    <div className="asset-view">
      {nonAudioAssets && nonAudioAssets.length > 0 && nonAudioContent()}
      {showCaption &&
        activeAsset &&
        activeAsset.caption &&
        activeAsset.caption !== "" && (
          <div className="asset-caption">
            <span>{activeAsset.caption}</span>
          </div>
        )}
      {audioAssets &&
        audioAssets.length > 0 &&
        audioAssets.map((audio, index) => {
          return (
            <div className="audio-asset">
              <UralityAudio asset={audio} />
              {onDelete && (
                <div className="delete-button">
                  <button
                    type="button"
                    className="a"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDelete(audio.id);
                    }}
                  >
                    <span className="material-icons">delete</span>
                  </button>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};
Asset.propTypes = {
  assets: PropTypes.object
};
export default Asset;
